var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopUpGreenDeskTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 290,
    viewBox: "0 0 349 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380 289.279C350.97 267.948 322.027 246.543 297.181 231.758C272.422 216.899 251.761 208.661 220.028 204.763C188.295 200.938 145.317 201.526 127.271 184.24C109.225 166.955 116.025 131.721 97.6303 108.551C79.2357 85.3804 35.6467 74.2733 15.6829 53.3833C-4.36805 32.4197 -0.793771 1.74662 2.78053 -29H380V289.279Z",
    fill: "#60FF52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopUpGreenDeskTop);
export default __webpack_public_path__ + "static/media/PopUpGreenDeskTop.be8b44b7bebc90e17a13656811855848.svg";
export { ForwardRef as ReactComponent };